import {
  TENANT_AT,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
} from 'shared/consts'
import type { Tenant } from 'types/shopConfig'

type TenantBasedExperiment = {
  [key in Tenant]?: {
    desktop: string
    mobile: string
  }
}

export const SERP_PRE_QUERY_SUGGESTIONS_PER_TENANT_EXPERIMENT = {
  [TENANT_COM]: { desktop: 'cro-2500', mobile: 'cro-2501' },
  [TENANT_AT]: { desktop: 'cro-2484', mobile: 'cro-2485' },
  [TENANT_FR]: { desktop: 'cro-2491', mobile: 'cro-2492' },
  [TENANT_IT]: { desktop: 'cro-2489', mobile: 'cro-2490' },
  [TENANT_CH]: { desktop: 'cro-2493', mobile: 'cro-2494' },
}

export const ALGOLIA_NEURAL_SEARCH_PER_TENANT_EXPERIMENT: TenantBasedExperiment =
  {
    [TENANT_COM]: {
      desktop: 'cro-2607',
      mobile: 'cro-2607',
    },
    [TENANT_IT]: {
      desktop: 'cro-2608',
      mobile: 'cro-2608',
    },
  }
